/** Check if scopes include the required permission (supports wildcards) */
const GLOBAL_WILDCARD_EXCLUDED_RESOURCES = new Set(['secret', 'source', 'sync', 'memory'])

export function checkScope(scopes: string[], permission: string): boolean {
  if (!permission.includes(':')) return false
  const [reqResource, reqAction] = permission.split(':')
  return scopes.some((s) => {
    if (!s.includes(':')) return false
    const [r, a] = s.split(':')
    // Sensitive post-legacy authorities must not be silently granted to old
    // broad API keys. Callers need `resource:*` or a concrete `resource:action`.
    if (r === '*' && GLOBAL_WILDCARD_EXCLUDED_RESOURCES.has(reqResource)) return false
    return (r === reqResource || r === '*') && (a === reqAction || a === '*')
  })
}
